// extracted by mini-css-extract-plugin
module.exports = {"error_template":"NotFound_error_template__1fEdW","error_actions":"NotFound_error_actions__768uF","btn":"NotFound_btn__3We3U"};